import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  view: 'upcoming', // upcoming | last | deleted
  loading: false,
  error: null,
  items: [],
  pagination: { currentPage: 1, lastPage: 1, perPage: 20, total: 0 },
  country: '',
  businessType: '',
  deletingId: null,
  confirmDeleteId: null,
}

const resetPaginationToFirstPage = state => {
  state.pagination.currentPage = 1
}

const applyFilterAndResetPage = (state, key, value) => {
  state[key] = value
  resetPaginationToFirstPage(state)
}

const resetDeletionState = state => {
  state.deletingId = null
  state.confirmDeleteId = null
}

const setViewHandler = (state, action) => {
  applyFilterAndResetPage(state, 'view', action.payload)
}


const setPageHandler = (state, action) => {
  state.pagination.currentPage = action.payload
}

const fetchStartHandler = state => {
  state.loading = true
  state.error = null
}

const fetchSuccessHandler = (state, action) => {
  state.loading = false
  state.items = action.payload.items
  state.pagination = action.payload.pagination
  state.error = null
}

const fetchErrorHandler = (state, action) => {
  state.loading = false
  state.error = action.payload
}

const openDeleteConfirmHandler = (state, action) => {
  state.confirmDeleteId = action.payload
}

const closeDeleteConfirmHandler = state => {
  state.confirmDeleteId = null
}

const deleteStartHandler = (state, action) => {
  state.deletingId = action.payload
}

const deleteFinishedHandler = state => {
  resetDeletionState(state)
}

const removeItemHandler = (state, action) => {
  state.items = state.items.filter(row => row.id !== action.payload)
  state.pagination.total = Math.max(0, state.pagination.total - 1)
  if (state.items.length === 0 && state.pagination.currentPage > 1) {
    state.pagination.currentPage -= 1
  }
}

const clearClientCallbacksHandler = () => initialState

const clientCallbacksSlice = createSlice({
  name: 'clientCallbacks',
  initialState,
  reducers: {
    setView: setViewHandler,
    setPage: setPageHandler,
    fetchStart: fetchStartHandler,
    fetchSuccess: fetchSuccessHandler,
    fetchError: fetchErrorHandler,
    openDeleteConfirm: openDeleteConfirmHandler,
    closeDeleteConfirm: closeDeleteConfirmHandler,
    deleteStart: deleteStartHandler,
    deleteFinished: deleteFinishedHandler,
    removeItem: removeItemHandler,
    clearClientCallbacks: clearClientCallbacksHandler,
  },
})

export const {
  setView,
  setPage,
  fetchStart,
  fetchSuccess,
  fetchError,
  openDeleteConfirm,
  closeDeleteConfirm,
  deleteStart,
  deleteFinished,
  removeItem,
  clearClientCallbacks,
} = clientCallbacksSlice.actions

export default clientCallbacksSlice.reducer
